module.exports = __webpack_public_path__ + "media/images/index-desc-fairy-42cebece4f132d8a327b96b6fe6d187a.svg";